import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  constructor(private httpClientService: HttpClientService) { }

  async createPerson(name: string, lastname: string, mission: string, email, number, address, companyId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Person
    },
      {
        name: name,
        lastName: lastname,
        mission: mission,
        phoneNumber: number,
        mail: email,
        address: address,
        companyId: companyId
      });
    return await firstValueFrom(observable);
  }

  async updatePerson(id: number, name: string, lastname: string, mission: string, email, number, address, companyId) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Person
    },
      {
        id: id,
        name: name,
        lastName: lastname,
        mission: mission,
        phoneNumber: number,
        mail: email,
        address: address,
        companyId: companyId
      });
    return await firstValueFrom(observable);
  }

  async updateWorker(workerData: any) {
    const observable: Observable<any> = this.httpClientService.put(
      {
        controller: ControllerType.Person,
        action: "UpdateWorker",
      },
      {
        id: workerData.id,
        name: workerData.name,
        lastName: workerData.lastName,
        mission: workerData.mission,
        phoneNumber: workerData.phoneNumber,
        mail: workerData.mail,
        address: workerData.address,
        companyId: workerData.companyId,
        updatePersonalAdditionalInfarmation: {
          id: workerData.updatePersonalAdditionalInfarmation.id,
          tc: workerData.updatePersonalAdditionalInfarmation.tc,
          birthDay: workerData.updatePersonalAdditionalInfarmation.birthDay,
          startDate: workerData.updatePersonalAdditionalInfarmation.startDate,
          department: workerData.updatePersonalAdditionalInfarmation.department,
          workingStatus: workerData.updatePersonalAdditionalInfarmation.workingStatus,
          wage: workerData.updatePersonalAdditionalInfarmation.wage,
          emergencyContact: workerData.updatePersonalAdditionalInfarmation.emergencyContact,
          personId: workerData.updatePersonalAdditionalInfarmation.personId,
          leaveJob:workerData.updatePersonalAdditionalInfarmation.leaveJob,
          workingDays:workerData.updatePersonalAdditionalInfarmation.workingDays,
          registrationNumber : workerData.updatePersonalAdditionalInfarmation.registrationNumber
        },
      }
    );

    return await firstValueFrom(observable);
  }

  async createWorker(workerData: any,workingDay?:any) {
    console.log(workerData);
    const birthDay = new Date(workerData.birthDay);
    const startDate = new Date(workerData.startDate);
    const leaveDate= new Date(workerData.leaveJob)
    const observable: Observable<any> = this.httpClientService.post(
      {
        controller: ControllerType.Person,
        action: "CreateWorker",
      },
      {
        name: workerData.name,
        lastName: workerData.lastName,
        mission: workerData.mission,
        phoneNumber: workerData.phoneNumber,
        mail: workerData.mail,
        address: workerData.address,
        companyId: 1,
        createPersonalAdditionalInfarmation: {
          tc: workerData.tc,
          birthDay: birthDay,
          startDate: startDate,
          department: workerData.department,
          workingStatus: workerData.workingStatus,
          wage: workerData.wage,
          emergencyContact: workerData.emergencyContact,
          personId: 0,
          leaveJob:leaveDate,
          workingDays:workingDay,
        },
      }
    );

    return await firstValueFrom(observable);
  }

  async createWorkers(workerData: any[]) {
    console.log(workerData);

    // Tüm çalışanlar için tarihleri doğru formatta hazırlayın
    const formattedWorkerData = workerData.map(worker => ({
      name: worker.name,
      lastName: worker.lastName,
      mission: worker.mission,
      phoneNumber: worker.phoneNumber,
      mail: worker.mail,
      address: worker.address,
      companyId: 1, // Varsayılan bir companyId
      createPersonalAdditionalInfarmation: {
        tc: worker.tc,
        birthDay: new Date(worker.birthDay), // Tarihi doğru formatta gönder
        startDate: new Date(worker.startDate), // Tarihi doğru formatta gönder
        department: worker.depertmant,
        workingStatus: worker.workingStatus,
        wage: worker.wage,
        emergencyContact: worker.emergenyContact,
        personId: 0, // Varsayılan bir personId,
        registrationNumber:worker.registrationNumber,
        workingDays:JSON.parse(worker.workingDays)
      },
    }));

    console.log(formattedWorkerData);
    // API'ye tüm çalışanları bir liste olarak gönderin
    const observable: Observable<any> = this.httpClientService.post(
      {
        controller: ControllerType.Person,
        action: "CreateWorkers",
      },
      formattedWorkerData // Tüm çalışanları bir liste olarak gönder
    );

    // Yanıtı bekleyin
    return await firstValueFrom(observable);
  }


  async getByIdPerson(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Person
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdWorker(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Person,
      action: "GetByIdWorker"
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdCompanyPersons(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Person,
      action: "GetByIdCompanyPersons"
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllPersons(page, size, search,workingStatus?:boolean) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Person,
      queryString: `Page=${page}&Size=${size}&search=${search}&WorkingStatus=${workingStatus}`
    });
    return await firstValueFrom(observable);
  }

  async getAllCompaniesPersons(page, size, companyId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Person,
      action: "GetByIdCompaniesPersons",
      queryString: `Page=${page}&Size=${size}&CompanyId=${companyId}`
    });
    return await firstValueFrom(observable);
  }



  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}